import { Charts } from './Charts';
import MappingChartsDataProvider from './contexts/MappingChartsDataContext';

const MappingWrapper = () => {
    return (
        <MappingChartsDataProvider>
            <Charts />
        </MappingChartsDataProvider>
    );
};

export default MappingWrapper;
